<template>
  <div style="width: 100%">
    <div
      v-if="showDetail"
      class="patient-detail"
    >
      <div class="patient-detail__title">
        <div class="patient-detail__crm">
          CRM
        </div>
        <div class="patient-detail__name">
          Médico(a)
        </div>
      </div>
      <div 
        v-for="(doctor, index) in doctors"
        :key="index"
        class="patient-detail__row"
      >
        <div class="patient-detail__crm">
          <p
            class="ellipsable"
            :title="doctor.crm + ' - ' + doctor.uf"
          >
            {{ doctor.crm + ' - ' + doctor.uf }}
          </p>
        </div>
        <div class="patient-detail__name">
          <p
            class="ellipsable"
            :title="doctor.name"
          >
            {{ doctor.name }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-else-if="show"
      class="patient-detail"
    >
      Esse paciente ainda não possui médico vinculado.
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamProfilesDetail',
  props: {
    doctors: {
      default: null,
      type: Array
    },
    show: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    showDetail () {
      if (this.show && this.doctors.length > 0) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.patient-detail {
  width: 100%;
  padding: 15px 20px;
  background: #F0F0F0;

  &__table {
    width: 100%;
    overflow: hidden;
  }
  &__table-head {
    text-align: left;
  }
  &__table-head {
    th {
      font-weight: bold;
      font-size: 10px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7A7A7A;
      line-height: 14px;
      padding-bottom: 5px;
    } 
  }
  &__title {
    & > div {
      font-weight: bold;
      font-size: 10px;
      line-height: 14px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7A7A7A;
      margin-bottom: 5px;
    }
  }
  &__row {
    & > div {
      font-size: 14px;
      line-height: 26px;
      color: #4A4A4A;
    }
  }

  &__title,
  &__row {
    display: flex;
  }
  &__name {
    width: calc(100% - 160px);
  }
  &__crm {
    width: 160px;
  }
}
</style>
